import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonList,
} from '@ionic/react';
import React, { type ReactNode } from 'react';
import styled from 'styled-components';

import Layout, { ButtonType } from '@components/Layout';

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;
  margin: 0px 16px;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 16px;
`;

const Card = styled(IonCard)`
  display: flex;
  align-items: center;
  padding: 20px;
`;

const CardIcon = styled(IonIcon)`
  color: var(--ion-text-color);
  /* Prevent the icon from shrinking on small screens with badge printing enabled */
  flex-shrink: 0;
`;

const CardText = styled.div`
  ion-card-header {
    padding: 0 0 8px 15px;
  }
  ion-card-title {
    font-size: 1.25rem;
    font-weight: 500;
  }
  ion-card-content {
    padding: 0 0 0 15px;
    font-size: 1.25rem;
  }
`;

const Content = styled(IonList)`
  background-color: var(--ion-background-color-step-50);

  > h2 {
    margin-left: 20px;
    font-size: 1.625em;
  }
`;

export interface DetailsListItem {
  onClick: () => void;
  icon?: string;
  title: string;
  subtitle?: string;
}

interface Props {
  header: ReactNode;
  pageTitle: string;
  callToAction: string;
  listItems: DetailsListItem[];
  footer?: ReactNode;
  buttonType?: ButtonType;
}

const DetailsList = ({
  header,
  pageTitle,
  callToAction,
  listItems,
  footer = undefined,
  buttonType = ButtonType.Back,
}: Props) => (
  <Layout title={pageTitle} buttonType={buttonType}>
    <Header>{header}</Header>
    <Content>
      <h2>{callToAction}</h2>
      {listItems.map(({ onClick, icon, title: itemTitle, subtitle }) => (
        <Card key={itemTitle} onClick={onClick}>
          <CardIcon size="large" icon={icon} />
          <CardText>
            <IonCardHeader>
              <IonCardTitle aria-level={3}>{itemTitle}</IonCardTitle>
            </IonCardHeader>
            {subtitle && <IonCardContent>{subtitle}</IonCardContent>}
          </CardText>
        </Card>
      ))}
    </Content>
    {footer && <Footer>{footer}</Footer>}
  </Layout>
);

export default DetailsList;
